import { Routes } from '@angular/router';
import { AuthLayoutComponent } from './feutures/auth/auth-layout/auth-layout.component';
import { MainLayoutComponent } from './feutures/main/main-layout/main-layout.component';
import {  loggedGuard } from './auth/guard/auth.guard';

export const appRoutes: Routes = [


  {
    path: '',
    component: MainLayoutComponent,
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },

      {
        path: 'home',
        loadComponent: () =>
          import('./pages/home/home.component').then(m => m.HomeComponent),
        title: 'Home',
      },
      {
        path: 'about',
        loadComponent: () =>
          import('./pages/about/about.component').then(m => m.AboutComponent),
        title: 'About',
      },
      {
        path: 'catogories',
        loadComponent: () =>
          import('./pages/catogories/catogories.component').then(m => m.CatogoriesComponent),
        title: 'Catogories',
      },
      {
        path: 'contact',
        loadComponent: () =>
          import('./pages/Contact/Contact.component').then(m => m.ContactComponent),
        title: 'Contact',
      },
      {
        path: 'occasions',
        loadComponent: () =>
          import('./pages/Occasions/Occasions.component').then(m => m.OccasionsComponent),
        title: 'Occasions',
      },
      {
        path: 'products',
        loadComponent: () =>
          import('./pages/products/products.component').then(m => m.ProductsComponent),
        title: 'Products',
      },
  {
  path: 'profile',
  loadComponent: () =>
    import('./pages/profile/profile.component').then(m => m.ProfileComponent),
  title: 'Profile',
  children: [
    {
      path: '',
      loadComponent: () =>
        import('./pages/profile/components/my-account/myAccount.component').then(m => m.MyAccountComponent),
      title: 'My Account',
    },
    {
      path: 'my-account',
      loadComponent: () =>
        import('./pages/profile/components/my-account/myAccount.component').then(m => m.MyAccountComponent),
      title: 'My Account',
    },
    {
      path: 'change-password',
      loadComponent: () =>
        import('./feutures/setting/pages/profile/change-password/changePassword.component').then(m => m.ChangePasswordComponent),
      title: 'Change Password',
    },
  ],
},
      {
        path: 'wishlist',
        loadComponent: () =>
          import('./pages/home/components/wishlist/wishlist.component').then(m => m.WishlistComponent),
        title: 'Products',
      
      },
      {
        path: 'address',
        loadComponent: () =>
          import('./pages/address/address.component').then(m => m.AddressComponent),
        title: 'address',
      
      },
      {
   
        path: 'allOrders',
        loadComponent: () =>
          import('./pages/allOrders/allOrders.component').then(m => m.AllOrdersComponent),
        title: 'allOrders',
      
      },
      {
        
        path: 'cart',
        loadComponent: () =>
          import('./feutures/cart/cart.component').then(m => m.CartComponent),
        title: 'Products',
      
      },
      {  path: 'details/:id',
        loadComponent: () =>
          import('./pages/products/details/details.component').then(m => m.DetailsComponent),
        title: 'Product Details',}
    ],
  },

  {
    path: '',
    component: AuthLayoutComponent,
    canActivate:[loggedGuard],
    children: [
      { path: 'login',
        loadComponent: () =>
          import('./feutures/auth/pages/login/login.component').then(m => m.LoginComponent),
        title: 'Login',
      },
      {
        path: 'register',
        loadComponent: () =>
          import('./feutures/auth/pages/register/register.component').then(m => m.RegisterComponent),
        title: 'Register',
      },
      {
        path: 'forget',
        loadComponent: () =>
          import('./feutures/auth/pages/forget/forget.component').then(m => m.ForgetComponent),
        title: 'Forget',
      },
    ],
  },
  {
    path: '**',
    loadComponent: () =>
      import('./pages/notfound/notfound.component').then(m => m.NotfoundComponent),
    title: 'Not Found',
  },

];



